// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconGlobe = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 8C17.191 8 8 17.191 8 32C8 46.809 17.191 56 32 56C46.809 56 56 46.809 56 32C56 17.191 46.809 8 32 8ZM41.2174 46.8627C39.1868 49.4241 36.9902 52 35 52C33.8438 52 33 51.3004 33 50C33 47.9357 34 47.3125 34 44C34 42.0823 26 42.7059 26 38C26 29 20 33.875 20 25C20 20.2916 24 19.7083 24 18C24 16.5 22 16.2108 22 15C22 13.2083 23.7917 12 28 12C32.2917 12 37 14.875 37 17C37 18.1823 36 18.6049 36 19.5C36 20.5252 36.7083 21 38 21C39.9583 21 41 21.5882 41 23C41 24.625 37.8047 29 32 29C29.3355 29 28 29.8438 28 31.5C28 33.2852 29.5706 34 32 34C40.9106 34 45 36.9688 45 40C45 41.9813 43.1724 44.3967 41.2174 46.8627Z" />
    </svg>
  );
};
